import React, { useState, useEffect } from "react";
import Header from "./Header";
import CSVViewer from "../CSVViewer";
import { Box } from "@mui/material";
import Loader from "../../../components/Loader";

function ExcelViewer({
  file,
  handleDeleteFile,
  handleUpdateFile,
  handleGoBack,
}) {
  const { chunks_url } = file;
  const [csvFileMap, setCsvFileMap] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCSV, setSelectedCSV] = useState(null);

  useEffect(() => {
    const fetchChunksJson = async () => {
      if (!chunks_url) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const response = await fetch(chunks_url);
        if (!response.ok) {
          throw new Error("Failed to fetch chunks JSON");
        }
        const data = await response.json();
        setCsvFileMap(data);

        // Set the first sheet as selected if available
        const csvList = Object.keys(data);
        if (csvList.length > 0) {
          setSelectedCSV(csvList[0]);
        }
      } catch (error) {
        console.error("Error fetching chunks JSON:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChunksJson();
  }, [chunks_url]);

  const handleChangeCSV = (csv) => {
    setSelectedCSV(csv);
  };

  const csvList = Object.keys(csvFileMap);

  if (isLoading) {
    return <Loader />;
  }

  if (csvList.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={400}>
        <span>No sheets available</span>
      </Box>
    );
  }

  return (
    <>
      <Header
        file={{ ...file, csv_file_map: csvFileMap }}
        selectedCSV={selectedCSV}
        handleChangeCSV={handleChangeCSV}
        handleGoBack={handleGoBack}
        handleDeleteFile={handleDeleteFile}
        handleUpdateFile={handleUpdateFile}
      />
      <Box
        flex={1}
        overflow={"auto"}
        sx={{
          borderBottomLeftRadius: 24,
          borderBottomRightRadius: 24,
        }}
        position={"relative"}>
        {selectedCSV && (
          <CSVViewer file={{ file_url: csvFileMap[selectedCSV] }} />
        )}
      </Box>
    </>
  );
}

export default ExcelViewer;
